import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "user",
  initialState: {
    data: {},
    file: null,
    videoTime: [] as any,
    loggedIn: false,
  },
  reducers: {
    setMeData(state, { payload }) {
      state.data = payload;
    },
    setVideoTime(state, { payload }) {
      const arr = state.videoTime;
      arr.findIndex((x: any) => x.id == payload.id) > -1
        ? (arr.find((x: any) => x.id == payload?.id).duration =
            payload.duration)
        : arr.push(payload);
      state.videoTime = arr;
    },
    setProfileFile(state, { payload }) {
      state.file = payload;
    },
    login(state, { payload }) {
      state.loggedIn = true;
    },
  },
});

export const { setMeData, setProfileFile, login, setVideoTime } = slice.actions;

export default slice.reducer;
